import React from "react";
import "./styles.css";
import Control from "./Control";
import SectionWithSwiper from "./SectionWithSwiper/SectionWithSwiper";
import Seguridad from "./Seguridad";
import ADTporque from "./ADTporque";
import Hero from "./Hero/Hero";
import NuevoSistema from "./NuevoSistema";
import Announcement from "./Announcement";
import WhatsappSection from "./WhatsappSection";
import CountdownBar from "./CountdownBar";
import FaqsSection from "./FaqsSection";

const Home = () => {
  return (
    <div className="home">
      <Announcement />
      <Hero heroImage="/og-image.jpg" />
      <Control />
      <SectionWithSwiper />
      <ADTporque />
      <Seguridad />
      <WhatsappSection />
      <FaqsSection />
      <NuevoSistema />
      <footer className="footer">
        <div className="container-lg flex flexCol alignCenter">
          <p>{new Date().getFullYear()} Alarmita.com - ADT Agente Oficial</p>
        </div>
      </footer>
      <CountdownBar />
    </div>
  );
};

export default Home;
